/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { PersonShowPathParams, PersonShowResponse } from '../types/PersonShow'

/**
 * GET /organisations/:organisationId/persons/:person
 * @see backend/nexus/modules/Campaign/Http/Controllers/PersonController.php PersonController::show
 */
export async function personShow(
	organisationId: PersonShowPathParams['organisationId'],
	person: PersonShowPathParams['person'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PersonShowResponse>> {
	return axiosInstance.get(`/organisations/${organisationId}/persons/${person}`, config)
}
